<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="确认完成"
      :innerHeight="120"
      :innerScroll="false"
      width="400px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <!-- // 业务 -->
      <div class="title">
        确定工作已完成？
      </div>
      <el-input v-model.trim="remark" type="textarea"  maxlength="128" show-word-limit></el-input>
      <div class="tips">如有异常情况，请进行信息备注。</div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'skuId', 'skuCode', 'taskId', 'spuId','renderShow'],
  data() {
    return {
      dialogVisible: false,
      // 业务
      remark: ''
    }
  },
  computed: {
    skuIds() {
      if(this.skuId instanceof Array) {
        return this.skuId
      }else{
        return [this.skuId]
      }
    },
    skuCodes() {
      if(this.skuCode instanceof Array) {
        return this.skuCode
      }else{
        return [this.skuCode]
      }
    },
  },
  mounted() {
    this.dialogVisible = this.visible;
    // 业务
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      if(this.renderShow) {
        this.completeRendering()
      }else if (this.spuId) {
        this.completeRetouching();
      } else if(!this.spuId) {
        this.completeTask();
      }
    },
    completeRetouching() {
      let params = {
        data: []
      };
      this.skuIds.forEach((item, index) => {
        params.data.push({
          skuId: item,
          spuId: this.spuId,
          remarks: this.remark
        })
      });
      this.$q.newProduct.completeRetouching(params)
        .then(({success}) => {
          if (success) {
            this.onSuccess();
          }
        });
    },
    completeTask() {
      let params = {
        data: []
      };
      this.skuIds.forEach((item, index) => {
        params.data.push({
          skuId: item,
          taskId: this.taskId,
          remarks: this.remark
        })
      });
      this.$q.newProduct.completeWork(params)
        .then(({success}) => {
          if (success) {
            this.onSuccess();
          }
        });
    },
    completeRendering() {
      let params = {
        data: []
      };
      this.skuIds.forEach((item, index) => {
        params.data.push({
          skuId: item,
          taskId: 111,
          remarks: this.remark
        })
      });
      this.$q.newProduct.completeRendering(params)
        .then(({success}) => {
          if (success) {
            this.onSuccess();
          }
        });
    },
    onSuccess() {
      this.updateVal();
      this.$notify.success({
        title: '成功',
        message: `确认完成成功`,
      });
      this.skuIds.length === 1 && this.$emit('success', {
        skuCode: this.skuCodes[0],
        skuId: this.skuIds[0]
      });
      this.skuIds.length > 1 && this.$emit('batchSuccess');
    },
  }
}
</script>

<style lang="stylus" scoped>
  .title
    font-size 14px
    font-weight bold
    line-height 36px
    display inline-block
    color #444
  .tips
    font-size 14px
    color #E63946
    line-height 36px
</style>